import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../utils/APIS";
import { IDS } from "../utils/IDS";
import { GET, POST } from "../utils/Methods";

export const createContact = createAsyncThunk(
  "masters/contact/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.contact, data);  // <-- send data here
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAlltermscondition = createAsyncThunk(
  "masters/termscondition/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.termscondition}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetAllprivacypolicy = createAsyncThunk(
  "masters/privacypolicy/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.privacypolicy}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const createcounsellingform = createAsyncThunk(
  "masters/counsellingform/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.counsellingform, data);  // <-- send data here
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const Alltypes = createAsyncThunk(
  "common/masters/all-types",
  async (filter = "", { rejectWithValue }) => {
    try {
      const url = `${APIS.Commons.AllTypes}?name=${filter}`;
      const res = await GET(url);
      const rawData = res?.data?.data || [];
      const mapped = rawData.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      return mapped;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllAppsetup = createAsyncThunk(
  "masters/appsetup/get-all",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.appsetup}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



export const Slice = createSlice({
  name: "contain",
  initialState: {
  contact: [],
  termscondition:[],
  privacypolicy:[],
  counsellingform:[],
  alltypes:[],
  appsetup:[],
 

 

    
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
  
        .addCase(createContact.pending, (state) => {
          state.status = IDS.SLICESTATUS.Loading;
        })
        .addCase(createContact.fulfilled, (state, action) => {
          state.status = IDS.SLICESTATUS.Succeeded;
          state.contact = action.payload?.data || [];
        })
        .addCase(createContact.rejected, (state, action) => {
          state.status = IDS.SLICESTATUS.Failed;
          state.error = action.payload;
         })

        .addCase(GetAlltermscondition.pending, (state) => {
          state.status = IDS.SLICESTATUS.Loading;
        })
        .addCase(GetAlltermscondition.fulfilled, (state, action) => {
          state.status = IDS.SLICESTATUS.Succeeded;
          state.termscondition = action.payload?.data || [];
        })
        .addCase(GetAlltermscondition.rejected, (state, action) => {
          state.status = IDS.SLICESTATUS.Failed;
          state.error = action.payload;
         })

         .addCase(GetAllprivacypolicy.pending, (state) => {
          state.status = IDS.SLICESTATUS.Loading;
        })
        .addCase(GetAllprivacypolicy.fulfilled, (state, action) => {
          state.status = IDS.SLICESTATUS.Succeeded;
          state.privacypolicy = action.payload?.data || [];
        })
        .addCase(GetAllprivacypolicy.rejected, (state, action) => {
          state.status = IDS.SLICESTATUS.Failed;
          state.error = action.payload;
         })

         .addCase(createcounsellingform.pending, (state) => {
          state.status = IDS.SLICESTATUS.Loading;
        })
        .addCase(createcounsellingform.fulfilled, (state, action) => {
          state.status = IDS.SLICESTATUS.Succeeded;
          state.counsellingform = action.payload?.data || [];
        })
        .addCase(createcounsellingform.rejected, (state, action) => {
          state.status = IDS.SLICESTATUS.Failed;
          state.error = action.payload;
         })
       
        .addCase(Alltypes.pending, (state) => {
          state.status = IDS.SLICESTATUS.Loading;
        })
        .addCase(Alltypes.fulfilled, (state, action) => {
          state.status = IDS.SLICESTATUS.Succeeded;
          // state.alltypes = action.payload?.data || [];
          state.alltypes = action.payload || [];
        })
        .addCase(Alltypes.rejected, (state, action) => {
          state.status = IDS.SLICESTATUS.Failed;
          state.error = action.payload;
         })

         .addCase(GetAllAppsetup.pending, (state) => {
          state.status = IDS.SLICESTATUS.Loading;
        })
        .addCase(GetAllAppsetup.fulfilled, (state, action) => {
          state.status = IDS.SLICESTATUS.Succeeded;
          // state.alltypes = action.payload?.data || [];
          state.appsetup = action.payload.data || [];
        })
        .addCase(GetAllAppsetup.rejected, (state, action) => {
          state.status = IDS.SLICESTATUS.Failed;
          state.error = action.payload.data;
         })

   
  },
});

export default Slice.reducer;